import { css } from 'styled-components'
import { temporaryTheme } from './theme'

/**
 * Tipografia compartilhada pelos documentos legais (política de privacidade e termos de uso).
 * Fica no container da página, e não no TextDanger, para vencer por especificidade o reset
 * `* { font-weight/font-size }` aplicado internamente pelo TextDanger.
 */
export const legalDocumentTypography = css`
  h2 {
    margin: 2.5rem 0 1rem;
    font-size: 1.125rem;
    font-weight: 700;
    color: ${temporaryTheme.colors.darkGrey};
  }

  p {
    margin: 0 0 1rem;
    text-align: justify;
  }

  .legal-version {
    font-style: italic;
  }

  .legal-item {
    padding-left: 1.5rem;
  }
`
